import { setupDynamicVideoButtons, setupMoodVideos } from '@eurotunnel-pax/leshuttle.ui/src/scripts/components/video/media-block'

export function handleCmsWidgetLoading () {
  document.addEventListener('cms-widget-loaded', function () {
    setupMoodVideos(document)
    setupDynamicVideoButtons(document)
  })
}
